<template>
	<app-select
		:options="options"
		:searchable="true"
		:clearOnSearch="true"
		:clearOnSelect="false"
		:placeholder="placeholder"
		:modelValue="modelValue"
		@select="$emit('update:modelValue', $event)"
		@deselect="$emit('update:modelValue', null)"
		:disabled="options.length === 1"
		track-by="restaurantName"
		value-prop="restaurantID"
		label-prop="restaurantName"
		label="restaurantName"
	>
		<template v-slot:option="{ option }">
			{{ option.restaurantName }} - {{ option.city && option.city.description }}
		</template>
	</app-select>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		name: 'RestaurantAutocomplete',
		props: {
			modelValue: {},
			placeholder: { type: String, default: 'Restaurant' },
			applyFirstOptionByDefault: { type: Boolean, default: false },
		},
		computed: {
			...mapGetters({
				user: 'user',
			}),
			options() {
				return this.user.restaurants;
			},
		},
		emits: ['update:modelValue'],
		methods: {
			applyFirstOption() {
				if (this.applyFirstOptionByDefault && this.options.length === 1) {
					this.$emit('update:modelValue', this.options[0].restaurantID);
				}
			},
		},
		mounted() {
			this.applyFirstOption();
		},
	};
</script>
